export default {
  mode: 'history',
  routes: [
    {
      path: '/',
      name: 'index',
      component: () => import('@/pages/index/'),
      meta: {
        layout: 'LayoutDefault'
      }
    }
  ]
}
